// 📧 Email Utilities for ACCTOO Backoffice
// Provides email normalization and validation utilities

/**
 * Normalizes an email address to ensure consistent formatting
 * Firebase Auth treats emails as case-insensitive, but we normalize
 * on the client side for consistency across our system
 * 
 * @param {string} email - The email address to normalize
 * @returns {string} - Normalized email address (trimmed and lowercased)
 */
export const normalizeEmail = (email) => {
  if (!email || typeof email !== 'string') {
    return '';
  }
  
  // Trim whitespace and convert to lowercase
  return email.trim().toLowerCase();
};

/**
 * Get user-friendly error message for Firebase Auth errors
 * Enhanced error messages for better user understanding
 * 
 * @param {string} errorCode - Firebase error code or message
 * @returns {string} - User-friendly error message
 */
export const getAuthErrorMessage = (errorCode) => {
  const errorMessages = {
    // Email/Password errors
    'auth/user-not-found': 'No account found with this email address.',
    'auth/wrong-password': 'Incorrect password. Please try again.',
    'auth/invalid-email': 'Please enter a valid email address.',
    'auth/invalid-credential': 'Invalid email or password.',
    'auth/email-already-in-use': 'This email address is already registered.',
    
    // Account status
    'auth/user-disabled': 'This account has been disabled.',
    'auth/too-many-requests': 'Too many failed attempts. Please wait and try again.',
    
    // Permission errors
    'permission-denied': 'You do not have permission to access the backoffice. Please contact an administrator.',
    
    // Network errors
    'auth/network-request-failed': 'Network error. Please check your connection.',
    
    // Generic errors
    'login-failed': 'Login failed. Please check your credentials and try again.',
    'bootstrap-failed': 'Failed to create admin account. Please try again.',
  };
  
  return errorMessages[errorCode] || 'An error occurred. Please try again.';
};

export default {
  normalizeEmail,
  getAuthErrorMessage
};








































